import { render, staticRenderFns } from "./ListTableDoc.vue?vue&type=template&id=92435af2&scoped=true&"
import script from "./ListTableDoc.vue?vue&type=script&lang=js&"
export * from "./ListTableDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92435af2",
  null
  
)

export default component.exports